
export const formatMoney = currencyCode => amount =>
  typeof amount !== 'undefined' && !Number.isNaN(amount) && amount.toLocaleString('en-US', { style: 'currency', currency: currencyCode })

